import { render } from "./TheNavbar.vue?vue&type=template&id=a3c3be06&scoped=true&ts=true&lang=pug"
import script from "./TheNavbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheNavbar.vue?vue&type=script&lang=ts&setup=true"

import "./TheNavbar.vue?vue&type=style&index=0&id=a3c3be06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c3be06"]])

export default __exports__